(function () {
  function clampPos(pos) {
    if (pos < -2) return -2;
    if (pos > 2) return 2;
    return pos;
  }

  function wrapDelta(delta, n) {
    if (n <= 0) return delta;
    const half = Math.floor(n / 2);
    if (delta > half) delta -= n;
    if (delta < -half) delta += n;
    return delta;
  }

  function initHero(root) {
    const slides = Array.from(root.querySelectorAll(".dcg-hero__slide"));
    if (!slides.length) return;

    const prevBtn = root.querySelector(".dcg-hero__nav--prev");
    const nextBtn = root.querySelector(".dcg-hero__nav--next");
    const dots = Array.from(root.querySelectorAll(".dcg-hero__dot"));

    // Inject SVG chevrons — replaces legacy text characters
    const CHEVRON_LEFT  = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>';
    const CHEVRON_RIGHT = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>';

    if (prevBtn) {
      prevBtn.insertAdjacentHTML('afterbegin', CHEVRON_LEFT);
      prevBtn.classList.add('dcg-hero__nav--has-svg');
    }
    if (nextBtn) {
      nextBtn.insertAdjacentHTML('afterbegin', CHEVRON_RIGHT);
      nextBtn.classList.add('dcg-hero__nav--has-svg');
    }

    let index = 0;
    let autoplayTimer = null;

    const autoplayEnabled = root.dataset.autoplay === "true";
    const interval = Number(root.dataset.interval || 6000);

    function setDots(i) {
      dots.forEach((d) => d.setAttribute("aria-selected", "false"));
      if (dots[i]) dots[i].setAttribute("aria-selected", "true");
    }

    function applySlideFitOverride(slide) {
      // Reads inline CSS var set by Liquid: --dcg-slide-fit: inherit|contain|cover
      const fit = (slide.style.getPropertyValue("--dcg-slide-fit") || "").trim();
      if (fit && fit !== "inherit") slide.setAttribute("data-fit", fit);
      else slide.removeAttribute("data-fit");
    }

    function render() {
      const n = slides.length;

      slides.forEach((slide, i) => {
        let delta = i - index;
        delta = wrapDelta(delta, n);
        const pos = clampPos(delta);

        slide.setAttribute("data-pos", String(pos));
        slide.setAttribute("aria-hidden", pos === 0 ? "false" : "true");

        // Per-slide fit override (independent control)
        applySlideFitOverride(slide);

        // Keep tab focus sane: only active slide links/buttons are tabbable
        const focusables = slide.querySelectorAll("a, button, input, select, textarea, [tabindex]");
        focusables.forEach((el) => {
          if (pos === 0) {
            if (el.hasAttribute("data-dcg-taboff")) {
              el.setAttribute("tabindex", el.getAttribute("data-dcg-taboff"));
              el.removeAttribute("data-dcg-taboff");
            } else if (el.getAttribute("tabindex") === "-1") {
              el.removeAttribute("tabindex");
            }
          } else {
            if (el.hasAttribute("tabindex")) {
              el.setAttribute("data-dcg-taboff", el.getAttribute("tabindex"));
            }
            el.setAttribute("tabindex", "-1");
          }
        });
      });

      setDots(index);
    }

    function goTo(i) {
      const n = slides.length;
      index = (i % n + n) % n;
      render();
    }

    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    function stopAutoplay() {
      if (autoplayTimer) window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled) return;
      autoplayTimer = window.setInterval(next, interval);
    }

    // Buttons
    if (prevBtn) prevBtn.addEventListener("click", () => { prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener("click", () => { next(); startAutoplay(); });

    // Dots
    dots.forEach((dot) => {
      dot.addEventListener("click", () => {
        const i = Number(dot.dataset.dotIndex || 0);
        goTo(i);
        startAutoplay();
      });
    });

    // Keyboard (only when focused inside slider)
    root.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        prev();
        startAutoplay();
      }
      if (e.key === "ArrowRight") {
        e.preventDefault();
        next();
        startAutoplay();
      }
    });

    // Pointer swipe
    let pointerDown = false;
    let startX = 0;
    let startY = 0;

    const viewport = root.querySelector(".dcg-hero__viewport");
    if (viewport) {
      viewport.addEventListener("pointerdown", (e) => {
        // Bug fix: do NOT capture the pointer when the user is clicking an
        // interactive element (a link, button, etc.) inside the viewport.
        // setPointerCapture() redirects all subsequent pointer events —
        // including pointerup — to the viewport itself, so the browser never
        // sees a matching pointerdown+pointerup on the link/button and the
        // synthesised click never fires. The button visually reacts (:active
        // triggers on pointerdown before capture) but navigation is silently
        // swallowed. Bailing out here lets clicks propagate normally while
        // swipe detection still activates for taps on the slide image.
        if (e.target.closest("a[href], button, input, select, textarea")) return;

        pointerDown = true;
        startX = e.clientX;
        startY = e.clientY;
        viewport.setPointerCapture?.(e.pointerId);
      });

      viewport.addEventListener("pointerup", (e) => {
        if (!pointerDown) return;
        pointerDown = false;

        const dx = e.clientX - startX;
        const dy = e.clientY - startY;

        // ignore mostly-vertical swipes
        if (Math.abs(dy) > Math.abs(dx)) return;

        if (dx > 35) {
          prev();
          startAutoplay();
        } else if (dx < -35) {
          next();
          startAutoplay();
        }
      });

      viewport.addEventListener("pointercancel", () => {
        pointerDown = false;
      });
    }

    // Initial
    render();
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll(".dcg-hero").forEach(initHero);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
})();